module.exports = __webpack_public_path__ + "img/loader.a255036c.gif";